import {
    GET_SHIFTWISEEMPLOYEES_REQUEST,
    GET_SHIFTWISEEMPLOYEES_SUCCESS
  } from "../Constants";
    
    export default (state = {}, action) => {
      switch (action.type) {
        case GET_SHIFTWISEEMPLOYEES_REQUEST:
          return {
            ...state,
            isFetching: action.isFetching
          };
        case GET_SHIFTWISEEMPLOYEES_SUCCESS:
          return {
            ...state,
            isFetching: action.isFetching,
            shiftViewList: action.shiftViewList
          };
        default:
          return state;
      }
    };
    